<div class="container-first-palm">

<div class="palm1-zoom">
  <img src="assets/{{client}}/palm/1.svg" class="palm1-move" />
</div>

<div class="palm2-zoom">
  <img src="assets/{{client}}/palm/2.svg" class="palm2-move" />
</div>

<div class="palm3-zoom">
  <img src="assets/{{client}}/palm/3.svg" class="palm3-move" />
</div>
</div>


<div class="container-reverse-palm">

  <div class="palm1-zoom">
    <img src="assets/{{client}}/palm/1.svg" class="palm1-move" />
  </div>

  <div class="palm2-zoom">
    <img src="assets/{{client}}/palm/2.svg" class="palm2-move" />
  </div>

  <div class="palm3-zoom">
    <img src="assets/{{client}}/palm/3.svg" class="palm3-move" />
  </div>


</div>

<div class="bt">
  <h1>{{ 'three_univers_title' | translate }}</h1>
  <ul>
    <li>
      <img src="assets/laterreta/custom/restaurant.svg" />
      <strong>{{ 'restaurant' | translate }}</strong>
    </li>
    <li>
      <img src="assets/laterreta/custom/chill.svg" />
      <strong>{{ 'garden_chill_out' | translate }}</strong>
    </li>
    <li>
      <img src="assets/laterreta/custom/golf.svg" />
      <strong>{{ 'mini_golf' | translate }}</strong>
    </li>
  </ul>
</div>
